// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"88e5820f","498":"e8a43685","703":"cffd8c95","787":"7e59da3f"}[chunkId] + ".chunk.js";
};